interface WithConsent {
  candidate_consent?: { anonymized?: boolean } | null;
}

// True when a candidate has been anonymized (GDPR-erased). Used to make row
// actions read-only across candidate tables.
export const isCandidateAnonymized = (
  candidate?: WithConsent | null
): boolean => !!candidate?.candidate_consent?.anonymized;
